<template>
  <div class="type">
    <div class="type-top">
      <div class="type-top-left"></div>
      营业执照
    </div>
    <div class="type-text" v-if="license != null">
      <!-- <div class="CodeText">
              备案号：<span> {{ license.BLFilingCode}}</span>
            </div> -->
      <div class="CodeText">
        企业名称：<span>{{ license.BLCompanyName }}</span>
      </div>
      <div class="CodeText">
        企业类型： <span>{{ license.BLCompanyType }}</span>
      </div>
      <div class="CodeText">
        统一社会信用代码： <span>{{ license.BLUnifiedSocialCreditCode }}</span>
      </div>
      <div class="CodeText">
        证照编号： <span>{{ license.BLLicenceCode }}</span>
      </div>
      <div class="CodeText">
        法定代表人： <span>{{ license.BLLegalRepresentative }}</span>
      </div>
      <div class="CodeText">
        经营范围： <span>{{ license.BLBusinessScope }}</span>
      </div>
      <div class="CodeText">
        起始时间： <span>{{ license.BLBusinessStartDate }}</span>
      </div>
      <div class="CodeText">
        失效时间： <span>{{ license.BLBusinessEndDate }}</span>
      </div>
      <div class="CodeText">
        注册资本： <span>{{ license.BLRegisteredCapital }}</span>
      </div>
      <div class="CodeText">
        成立时间： <span>{{ license.BLEstablishmentDate }}</span>
      </div>
      <div class="CodeText">
        住所： <span>{{ license.BLAddress }}</span>
      </div>
      <div class="CodeText">
        驳回时间： <span>{{ license.RejectTime }}</span>
      </div>
      <div class="CodeText">
        驳回原因： <span>{{ license.RejectReason }}</span>
      </div>
      <div class="CodeText">
        营业执照：
        <div class="imgBox">
          <!-- ${ config.http_URL } + -->
          <img :src="`${license.BLPhotoURL}`">
        </div>
        <div class="imgTop"><img src="@/assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(license.BLPhotoURL)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    license: {
      type: Object
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    imgShowClick(par) {
      this.$emit('imgShowClick', par)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url("../index.less");
</style>